import {
  FaChevronCircleDown,
  FaChevronCircleUp,

} from "react-icons/fa";
import { MdArrowForwardIos } from "react-icons/md";
import { styled } from "@mui/system";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import { colors, others } from "../../../styles/colors";
import { ServiceStatus, UrgencyStatus } from "../../../constants/Disciplines";
import { PatientList } from "../../../models/Authorization";
import fontWeight from "../../../styles/mui/fontWeight";

export const GridBody = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1.5rem 1.5rem 0 2rem",
  marginBottom: "0.8rem",
  paddingBottom: "1.2rem",
  borderRadius: "0.8rem",
  display: "flex",
});

export const DisciplineGridBody = () => ({
  background: colors.backgroundColor[7],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1.2rem 1.5rem",
  marginBottom: "0.8rem",
  borderRadius: "0.8rem",
  display: "flex",
});

export const VerticalDivider = () => ({
  margin: "0 1.2rem",
});

export const HorizontalDivider = () => ({
  margin: "1rem 0",
  minWidth: "100%",
  width: "95%",
  opacity: 0.6,
});

export const FaChevronCircleDownIcon = styled(FaChevronCircleDown)(() => ({
  color: colors.fonts[18],
  fontSize: "1.2rem",
  cursor: "pointer",
}));

export const FaChevronCircleUpIcon = styled(FaChevronCircleUp)(() => ({
  color: colors.fonts[18],
  fontSize: "1.2rem",
  cursor: "pointer",
}));

export const GridTableContent = () => ({
  padding: "1rem 0 1rem 1rem",
});

export const DisciplineTableCell = () => ({
  paddingTop: "0.4rem",
  paddingRight: "1rem",
});

export const CancelBtn = () => ({
  background: others.otherColors[33],
});

export const FormControlStyle = () => ({
  paddingBottom: "2rem",
});

export const FaIconBox = {
  width: "0.7rem",
  height: "0.7rem",
  cursor: "pointer",
};

export const displayFlex = () => ({
  display: "flex",
});

export const TableMain = styled(Table)(() => ({
  "& .MuiTableCell-root": {
    borderRight: "none",
    borderLeft: "none",
    paddingLeft: "0.5rem",
    paddingRight: "0.7rem",
  },
  "& th:first-of-type": {
    borderRadius: "0.7rem 0 0 0.7rem",
    borderRight: "1rem",
  },
  "& th:last-of-type": {
    borderRadius: "0 0.7rem 0.7rem 0",
  },
}));
export const TableMainHead = styled(TableHead)(() => ({
  backgroundColor: colors.backgroundColor[8],
  borderBottom: "unset",
  padding: ".4rem 0 0 0",
  "& th:first-of-type": {
    borderRadius: "0.7rem 0 0 0.7rem",
  },
  "& th:last-child": {
    borderRadius: "0 0.7rem 0.7rem 0",
  },
}));

export const TableMainHeadRow = styled(TableRow)(() => ({
  height: "2rem",
}));

export const TableCellStickyHeader = styled(TableCell)(() => ({
  borderBottom: "none",
  "&.MuiTableCell-root:last-child": {
    backgroundColor: colors.backgroundColor[8],
    position: "sticky",
    right: 0,
  },
}));

export const AlignCenter = {
  display: "flex",
  alignItems: "center",
};

export const DisciplineContainerStyle = {
  "&::-webkit-scrollbar": {
    width: 0,
    height: "0.2rem",
  },
  "&::-webkit-scrollbar-track": {
    width: 0.1,
    marginLeft: "6rem",
    marginRight: "50rem",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: colors.black[7],
    borderRadius: 0.1,
    width: 0.1,
  },
};

export const PatientTableCell = () => ({
  borderRight: 0,
  padding: 0,
  textAlign: "left",
  paddingRight: "1%",
  paddingLeft: "0rem",
  borderBottom: `1px solid ${colors.dropShadow[1]}`,
});

export const VisitTableCell = () => ({
  borderRight: 0,
  padding: 0,
  textAlign: "center",
  paddingRight: "1%",
  paddingLeft: "0rem",
  borderBottom: `1px solid ${colors.dropShadow[1]}`,
});

export const TableCellSticky = styled(TableCell)(() => ({
  position: "sticky",
  right: 0,
  background: others.otherColors[33],
}));

export const ViewBoxStyle = {
  width: "auto",
  display: "flex",
  alignItems: "center",
};

export const TableHeight = {
  height: "3rem",
};

export const HeaderTitle = () => ({
  paddingTop: "0.3rem",
  paddingLeft: "1rem",
});

export const HeaderTableCell = () => ({
  borderBottom: "unset",
  "&.MuiTableCell-root:last-child": {
    borderBottom: "none",
  },
});

export const ReviewButton = {
  width: "6rem",
};

export const Action = {
  paddingLeft: "1rem",
};

export const TranslationText = () => ({
  paddingTop: "1rem",
});

export const ReviewArrowIcon = styled(MdArrowForwardIos)(() => ({
  fontSize: "0.7rem",
  margin: "0.1rem 0.3rem",
  color: colors.white[1],
}));

export const ReviewArrowIconDown = styled(MdArrowForwardIos)(() => ({
  fontSize: "0.7rem",
  margin: "0.1rem 0.3rem",
  color: colors.white[1],
  transform: "rotate(90deg)",
}));

export const DisplayNone = () => ({
  display: "none",
});

export const PostServiceReviewModalContainer = () => ({
  position: "relative",
  minWidth: "fit-content",
  maxWidth: "80vw",
  backgroundColor: colors.white[1],
  borderRadius: "",
  padding: "1.5rem",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
  textAlign: "center",
});

export const ShowIcon = () => ({
  display: "flex",
  justifyContent: "end",
  marginRight: "0.3rem",
  marginTop: "0.2rem",
});

export const ApprovedVisitsGridBody = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  display: "flex",
  position: "absolute",
  top: "100%",
  left: 0,
  width: "100%",
  zIndex: 2,
});

export const serviceStatusColor = (color: string) => {
  switch (color) {
    case ServiceStatus.PENDING:
      return others.otherColors[72];
    case ServiceStatus.EXPEDITED:
      return colors.red[100];
    case ServiceStatus.STANDARD:
      return colors.black[5];
    default:
      return colors.black[3];
  }
};

export const urgencyStatusColor = (color: string) => {
  switch (color) {
    case UrgencyStatus.EXPEDITED:
      return colors.red[100];
    case UrgencyStatus.STANDARD:
      return colors.black[5];
    default:
      return "";
  }
};
export const getColorValue = (data: PatientList, row:Record<string,string> , disciplineList: PatientList[]) => {
  if (data.value === disciplineList[10].value) {
    return serviceStatusColor(row[data.value]);
  } else if (data.value === disciplineList[2].value) {
    return urgencyStatusColor(row[data.value]);
  } else {
    return data.fieldValue;
  }
};

export const DocumentDetailsTableCell = { padding: "0" };

export const DocumentName = {
  display: "block",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  maxWidth: "10rem",
  textDecoration: "unset",
};
export const MainContainer = () => ({
  display: "flex",
  alignItems: "center",
});

export const MainConatiner = MainContainer;

export const ApprovedVisitContainer = () => ({
  display: "flex",
  justifyContent: "flex-end",
});

export const ApprovedVisitValue = () => ({
  paddingTop: "0.3rem",
  paddingLeft: "0.3rem",
});

export const CancelButton = () => ({
  justifyContent: "flex-end",
  display: "flex  ",
  padding: "1rem",
});

export const ReadOnlyFieldLabel = () => ({
    marginBottom: "0.25rem",
    whiteSpace: "nowrap",
});

export const breadcrumbsStyle = {
  mb: "1rem",
  "& .MuiBreadcrumbs-separator": {
    mx: 0,
  },
};
export const breadcrumbLinkStyle = {
  cursor: "pointer",
  fontWeight: fontWeight.Weight[6],
  textDecoration: "underline",
  "&:hover": {
    color: colors.fonts[6],
  },
};